// src/pages/BirthdayCelebrationPage.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import '../styles/EventPackagePage.css';
import Footer from '../components/Footer';

import buffet8 from '../assets/buffet8.jpg';
import buffet9 from '../assets/buffet9.jpg';
import buffet10 from '../assets/buffet10.jpg';
import buffet11 from '../assets/buffet11.jpg';
import buffet12 from '../assets/buffet12.jpg';
import buffet13 from '../assets/buffet13.jpg';
import buffet14 from '../assets/buffet14.jpg';
import buffet15 from '../assets/buffet15.jpg';
import buffet16 from '../assets/buffet16.jpg';
import buffet17 from '../assets/buffet17.jpg';
import buffet18 from '../assets/buffet18.jpg';
import buffet19 from '../assets/buffet19.jpg';
import buffet20 from '../assets/buffet20.jpg';
import buffet21 from '../assets/buffet21.jpg';
import buffet22 from '../assets/buffet22.jpg';

const IMAGES = [
  buffet8, buffet9, buffet10, buffet11, buffet12, buffet13,
  buffet14, buffet15, buffet16, buffet17, buffet18, buffet19,
  buffet20, buffet21, buffet22,
];

const WHATSAPP_HREF =
  'https://wa.me/6590079953?text=Hi%20Lebua%20Thai%2C%20I%27d%20like%20to%20enquire%20about%20booking%20a%20Birthday%20Celebration.';

const BirthdayCelebrationPage = () => (
  <div className="event-package-page">
    <header className="event-package-hero">
      <span className="event-package-hero__eyebrow">Book for Events</span>
      <h1 className="event-package-hero__title">Birthday Celebration</h1>
      <p className="event-package-hero__sub">
        Celebrate another year in style at Lebua Thai. Set within the
        heritage charm of CHIJMES, our space pairs a warm, festive
        atmosphere with authentic Thai flavours — perfect for birthdays
        big or small, with family or friends.
      </p>
      <a
        href={WHATSAPP_HREF}
        className="btn btn-primary event-package-hero__cta"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faWhatsapp} /> Enquire on WhatsApp
      </a>
    </header>

    <div className="event-package-grid">
      {IMAGES.map((img, i) => (
        <div key={i} className="event-package-item">
          <img
            src={img}
            alt={`Birthday celebration at Lebua Thai ${i + 1}`}
            loading="lazy"
          />
        </div>
      ))}
    </div>

    <section className="event-package-reserve">
      <h2>Planning a Birthday?</h2>
      <p>Tell us the date, headcount, and any special touches — we'll help make it memorable.</p>
      <a
        href={WHATSAPP_HREF}
        className="btn btn-primary"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faWhatsapp} /> Enquire on WhatsApp
      </a>
    </section>

    <Footer />
  </div>
);

export default BirthdayCelebrationPage;
